import { TranslateService } from "@ngx-translate/core";
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
export class UnsavedChangesGuard {
    constructor(OBJ_translate_service) {
        this.OBJ_translate_service = OBJ_translate_service;
    }
    canDeactivate(OBJ_detail_component, OBJ_current_route, OBJ_current_state, OBJ_next_state) {
        if (OBJ_detail_component.hasUnsavedChanges()) {
            return confirm(this.OBJ_translate_service.instant("oDetail.sUnsavedChanges"));
        } // end if
        return true;
    }
}
UnsavedChangesGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UnsavedChangesGuard_Factory() { return new UnsavedChangesGuard(i0.ɵɵinject(i1.TranslateService)); }, token: UnsavedChangesGuard, providedIn: "root" });
